import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { ILabel } from "@schema/label";

@Component({
  selector: "app-label",
  templateUrl: "./label.component.html",
  styleUrls: ["./label.component.scss"]
})
export class LabelComponent implements OnInit {

  /**
   * The label to display
   */
  @Input()
  public label: ILabel;

  /**
   * If the user can edit (remove) the label
   */
  @Input()
  public isEditable = false;

  /**
   * Event for when the label"s X is clicked (when applicable)
   */
  @Output()
  public removeFromCollection = new EventEmitter<string>();

  constructor() { }

  ngOnInit(): void { }

  /**
   * Handles when the X is clicked, used to remove the label from the collection.
   */
  public remove(): void {
    this.removeFromCollection.emit(this.label.id);
  }

}
